import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';

import {Link} from 'react-router';

class PrivacyPolicy extends React.Component {

    render() {
        return <FullWidthPage title="Поверителност">
            <div className="col-md-12">
                <SectionTitle>Поверителност</SectionTitle>

                <p>Ние защитаваме личните данни на нашите потребители. Настоящата политика обяснява по какъв начин се
                    обработва информацията на посетителите на <Link to="/">medita.bg</Link> .</p>
                <h3>Лични данни</h3>
                <p>Ние записваме ограничен набор от лични данни, за да можем да ви предоставим нашата услуга. Вие ни
                    предоставяте:</p>
                <ul>
                    <li>Валиден имейл, за да можем да се свържем с Вас в случай на забравена парола или с напомнящо
                        писмо;
                    </li>
                    <li>Потребителско име, което може да е напълно измислено.</li>
                </ul>


                <p>Ние се задължаваме да не разкриваме личните Ви данни на други лица и организации с изключение на
                    изрично предвидените в закона случаи. Във всеки един момент Вие имате право да изтриете акаунта си
                    или да ни помолите да го направим вместо Вас.</p>
                <h3>Сървърни логове и бисквитки</h3>

                <p>Нашият сайт използва Google Analytics, за да събира неидинтифицираща информация с цел подобряване на
                    услугата ни.</p>
                <p>Сървърите на <Link to="/">medita.bg</Link> записват информация за IP адресите и отчитат
                    трафик като всеки стандартен интернет сървър.</p>

                <h3>Реклама</h3>

                <p>Нашият екип рекламира <Link to="/">medita.bg</Link> в социалните мрежи и използва наличните
                    технологии с цел оптимизиране на рекламните ни усилия.</p>
                <p>Платформи като Facebook където е възможно Вие да имате профил, ще използват тази информация, за да Ви
                    покажат реклами на <Link to="/">medita.bg</Link> ако сте посетили нашата страница или имате
                    интереси, свързани с медитации на български език.</p>
                <p>Настоящата политика е част от Условията за ползване на този сайт и като такава следва да бъде
                    тълкувана и прилагана в съответствие със законите на Република България.</p>


            </div>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(PrivacyPolicy);




// WEBPACK FOOTER //
// ./src/components/Pages/PrivacyPolicy.js